import React from "react";
import { useNavigate } from "react-router-dom";
import BaseCard from "src/app/components/commonComponents/BaseCard";
import ObservationCardInternalDetails from "src/app/components/ObservationCardInternalDetails";
import { AppRoutes } from "src/app/navigation/routes";
import { Observation } from "src/shared/types/src";

const ObservationCard = ({ details }: { details: Observation }) => {
    const navigate = useNavigate();
    // onPressFunc = {() => navigate(AppRoutes.OBSERVATION_DETAILS_SCREEN(details?.id), { state: { observationDetails: details } })}
    return (
        <div className="mg-t-15">
            <BaseCard clickable={true}>
                <ObservationCardInternalDetails details={details} />
            </BaseCard>
        </div>
    )
}

export default ObservationCard;